import React, { Component } from 'react';

class App extends Component {
	constructor(props) {
		super(props);

		this.apiRoot = '//nidhoggur.rhi.hi.is/ritaskra/api/baejatal';

		this.formControlChangeHandler = this.formControlChangeHandler.bind(this);

		this.state = {
			sveitarfelog: [],
			sveitarfelogGomul: [],
			syslur: [],

			searchFields: {
				searchInput: '',
				selectedSveitarfelag: '',
				selectedSveitarfelagGamalt: '',
				selectedSysla: '',
			},

			data: []
		};

		fetch(this.apiRoot+'/syslur')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					syslur: json.results
				})
			}.bind(this));

		fetch(this.apiRoot+'/sveitarfelog/ny')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					sveitarfelog: json.results
				})
			}.bind(this));

		fetch(this.apiRoot+'/sveitarfelog/gomul')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					sveitarfelogGomul: json.results
				})
			}.bind(this));
	}

	formControlChangeHandler(event) {
		event.persist();

		let searchFields = {
			searchInput: '',
			selectedSveitarfelag: '',
			selectedSveitarfelagGamalt: '',
			selectedSysla: '',
		};

		searchFields[event.target.name] = event.target.value;

		this.setState({
			searchFields: searchFields
		}, function() {
			if (event.target.name != 'searchInput') {
				this.search();
			}
		}.bind(this));
	}

	search() {
		let params = [
			'limit=2000'
		];

		if (this.state.searchFields.searchInput) {
			params.push('nafn='+this.state.searchFields.searchInput+'*');
		}
		if (this.state.searchFields.selectedSveitarfelag) {
			params.push('nuv_sveitarf='+this.state.searchFields.selectedSveitarfelag);
		}
		if (this.state.searchFields.selectedSveitarfelagGamalt) {
			params.push('gamalt_sveitarf='+this.state.searchFields.selectedSveitarfelagGamalt);
		}
		if (this.state.searchFields.selectedSysla) {
			params.push('sysla='+this.state.searchFields.selectedSysla);
		}

		fetch(this.apiRoot+'/baeir?'+params.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json.results
				})
			}.bind(this));
	}

	render() {
		let firstLetters = [
			'A',
			'Á',
			'B',
			'C',
			'D',
			'E',
			'É',
			'F',
			'G',
			'H',
			'I',
			'Í',
			'J',
			'K',
			'L',
			'M',
			'N',
			'O',
			'Ó',
			'P',
			'Q',
			'R',
			'S',
			'T',
			'U',
			'Ú',
			'V',
			'X',
			'Y',
			'Ý',
			'Z',
			'Þ',
			'Æ',
			'Ö',
		];

		return (
			<div>

				<h3>Bæir í stafrófsröð</h3>

				<p>
					{
						firstLetters.map(function(item) {
							return <React.Fragment><a href="#" onClick={function(event) {
								event.preventDefault();

								this.setState({
									searchFields: {
										searchInput: item
									}
								}, function() {
									this.search();
								})
							}.bind(this)}>{item}</a> </React.Fragment>;
						}.bind(this))
					}
				</p>
				<hr/>

				<div className="c-form-element">
					<label className="c-label">Almenn leit</label>

					<input type="text" 
						className="form-text"
						name="searchInput" 
						value={this.state.searchFields.searchInput} 
						onChange={this.formControlChangeHandler}
						onKeyDown={function(event) {
							if (event.keyCode == 13) { // enter
								this.search();
							}
						}.bind(this)} />
				</div>

				<div>
					<h3>Leita eftir sveitarfélögum og sýslum</h3>

					<div className="c-form-element">
						<label className="c-label">Sveitarfélög (núverandi)</label>
						<div className="o-input o-input--select">
							<select name="selectedSveitarfelag" 
								className="form-select required c-input c-input--select"
								value={this.state.searchFields.selectedSveitarfelag} onChange={this.formControlChangeHandler}>
								<option value="0">Veldu sveitarfélag</option>
								{
									this.state.sveitarfelog.map(function(item, index) {
										return <option key={index} value={item.id}>{item.skst}</option>;
									})
								}
							</select>
						</div>
					</div>

					<div className="c-form-element">
						<label className="c-label">Sveitarfélög (1970)</label>
						<div className="o-input o-input--select">
							<select name="selectedSveitarfelagGamalt" 
								className="form-select required c-input c-input--select"
								value={this.state.searchFields.selectedSveitarfelagGamalt} onChange={this.formControlChangeHandler}>
								<option value="0">Veldu sveitarfélag</option>
								{
									this.state.sveitarfelogGomul.map(function(item, index) {
										return <option key={index} value={item.id}>{item.skst}</option>;
									})
								}
							</select>
						</div>
					</div>

					<div className="c-form-element">
						<label className="c-label">Sýslur</label>
						<div className="o-input o-input--select">
							<select name="selectedSysla" 
								className="form-select required c-input c-input--select"
								value={this.state.searchFields.selectedSysla} onChange={this.formControlChangeHandler}>
								<option value="0">Veldu sýslu</option>
								{
									this.state.syslur.map(function(item, index) {
										return <option key={index} value={item.id}>{item.nafn}</option>;
									})
								}
							</select>
						</div>
					</div>

				</div>

				{
					this.state.data.length > 0 &&
					<table>
						<thead>
							<tr>
								<th>id</th>
								<th>Bæjarnafn</th>
								<th>Sveitarfélag (núverandi)</th>
								<th>Sveitarfélag (1970)</th>
								<th>Sýsla</th>
							</tr>
						</thead>
						<tbody>
							{
								this.state.data.map(function(item, index) {
									return <tr key={index}>
										<td>{item.id}</td>
										<td>{item.baejarnafn}</td>
										<td>{item.nuv_sveitarf.skst}</td>
										<td>{item.gamalt_sveitarf.skst}</td>
										<td>{item.sysla.nafn}</td>
									</tr>;
								})
							}
						</tbody>
					</table>
				}

			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js